.container {
  display: flex;
  align-items: center;
}

.input {
  width: 150px;
}

.omniButton {
  margin-left: 8px;
}
